module.exports = __webpack_public_path__ + "static/img/guard_type_xz2.3d17cc8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/guard/guard_type_xz2.png
// module id = RXpO
// module chunks = 0